import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationLocationWamsConstants {
    static STEP_TITLE = "Location";
    static DETAILS_FORM_GROUP = "detailsForm";
    static LOCATION_FORM_GROUP_NAME = "locationForm";
    static APPLICANT_FORM_GROUP_NAME = "applicantForm";
    static APPLICANT_AGENT_FORM_GROUP_NAME = "applicantAgentForm";
    static PROFESSIONAL_BODIES_FORM_GROUP_NAME = "professionalBodiesForm";
    static NOTE_FORM_GROUP_NAME = "notesForm";
    static DOCUMENTATION_FORM_GROUP_NAME = "documentForm";
    static NOTE_FORM_CONTROL_NAME = "note";
    static ACCEPT_LABEL = "I accept";
    static RESUBMISSION_DISCLAIMER_TITLE_LABEL_MESSAGE = "Resubmission Disclaimer title not configured, please contact your system administrator";
    static RESUBMISSION_DISCLAIMER_CONTENT_LABEL_MESSAGE = "Resubmission Disclaimer content not configured, please contact your system administrator";
    static ACCEPT_FORM_CONTROL_NAME = "acceptControl";
    static APPLICANT_FORM_CONTROL_NAME = "applicantRecipient";
    static APPLICANT_AGENT_FORM_CONTROL_NAME = "applicantAgentRecipient";
    static IMPLEMENTING_AGENT_FORM_CONTROL_NAME = "implementingAgentRecipient";
    static ENGINEER_FORM_CONTROL_NAME = "engineerRecipients";
    static RESPONSIBLE_CONTRACTOR_FORM_CONTROL_NAME = "responsibleContractorRecipient";
    static MARK_IMPLEMENTING_AGENT_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markImplementingAgentAsNotApplicable";
    static MARK_ENGINEER_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markEngineerAsNotApplicable";
    static MARK_CONTRACTOR_AS_NOT_APPLICABLE_FORM_CONTROL_NAME = "markContractorAsNotApplicable";
    static DESCRIPTION_LABEL_1 = "Use the 'Search for place or address' bar on the right to search for your location. Draw a point, line or polygon on the map to indicate the location of the wayleave.";
    static DESCRIPTION_LABEL_2 = "If you would like to use the zoom function, use the 'Select tool' on the toolbar on the left to navigate to your location.";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static LAYER_REF = "Wayleave graphics";
    static IS_RESUBMISSION_FORM_CONTROL_NAME = "isResubmission";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME = "previousReferenceNumber";
    static IS_RESUBMISSION_LABEL = "Is this application a resubmission?";
    static PREVIOUS_REFERENCE_NUMBER_LABEL = "Previous reference number";
    static RESUBMISSION_VERIFICATION_MESSAGE = "Reference number verification successful";
    static RESUBMISSION_VERIFICATION_MESSAGE_FAILURE = "Reference number verification unsuccessful";
    static VERIFY_LABEL = "Verify";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static CLIENT_REFERENCE_NUMBER_FORM_CONTROL_NAME = "clientReferenceNumber";
    static APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_FORM_CONTROL_NAME = "applicantTelecommunicationLicenseNumber";
    static SCOPE_OF_WORK_FORM_CONTROL_NAME = "scopeOfWork";
    static ESTIMATED_CONSTRUCTION_COST_FORM_CONTROL_NAME = "estimatedConstructionCost";
    static APPLICATION_FEE_FORM_CONTROL_NAME = "applicationFee";
    static CONSTRUCTION_PERIOD_FORM_CONTROL_NAME = "constructionPeriod";
    static SERVICES_FORM_CONTROL_NAME = "services";
    static PROPOSED_START_DATE_FORM_CONTROL_NAME = "proposedStartDate";
    static PROPOSED_END_DATE_FORM_CONTROL_NAME = "proposedEndDate";
    static LANE_CLOSURE_IS_REQUIRED_FORM_CONTROL_NAME = "laneClosureIsRequired";
    static LANE_CLOSURE_EXTENT_FORM_CONTROL_NAME = "laneClosureExtent";
    static CONSTRUCTION_PERIOD_UNITS_FORM_CONTROL_NAME = "constructionPeriodUnits";
    static ELECTRICAL_SERVICES_FORM_CONTROL_NAME = "electricalServices";
    static ACTUAL_START_DATE_FORM_CONTROL_NAME = "actualStartDate";
    static ACTUAL_END_DATE_FORM_CONTROL_NAME = "actualEndDate";
    static VALIDATION_MESSAGES = {
        erfNo: {
            required: `Erf no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        allotment: {
            required: `Allotment ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sgCode: {
            required: `SG code ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        address: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        erfSize: {
            required: `Erf size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeed: {
            required: `Title deed ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        zone: {
            required: `Zone ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        propertyDescription: {
            required: `Property description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        titleDeedRestrictions: {
            required: `Title deed restrictions ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        externalWalls: {
            required: `External walls ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        internalWalls: {
            required: `Internal walls ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        roofing: {
            required: `Roofing walls ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        numberOfHousesUnits: {
            required: `Number of houses / units ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalExisting: {
            required: `Total existing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalAdded: {
            required: `Total added ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalFloorArea: {
            required: `Total floor area ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        coveredExisting: {
            required: `Covered existing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        coveredAdded: {
            required: `Covered added ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        openExisting: {
            required: `Open existing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        openAdded: {
            required: `Open added ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalExistingPatio: {
            required: `Total existing ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        totalAddedPatio: {
            required: `Total added ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        pool: {
            required: `Pool ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        boundaryWallHeight: {
            required: `Boundary wall height ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        boundaryWallRunning: {
            required: `Boundary wall running ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        coverage: {
            required: `Coverage ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        bulkCalculation: {
            required: `Bulk calculation ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        floor: {
            required: `Floor ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        existingSize: {
            required: `Existing size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        addedSize: {
            required: `Added size ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isResubmission: {
            required: `Is resubmission ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        previousReferenceNumber: {
            required: `Previous reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
